import React, { useState, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import ActiveTimerIndicator from '@/components/ActiveTimerIndicator';
import OfflineBanner from '@/components/OfflineBanner';
import PendingSyncPanel from '@/components/PendingSyncPanel';
import FloatingChatbot from '@/components/FloatingChatbot'; // DISABLED - da rimuovere
import AuthPage from '@/pages/AuthPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardPage from '@/pages/DashboardPage';
import ClientiPage from '@/pages/ClientiPage';
import OrdiniLavoroPage from '@/pages/OrdiniLavoroPage';
import ProgettiPage from '@/pages/ProgettiPage';
import CantieriPage from '@/pages/CantieriPage';
import CantiereDetailPage from '@/pages/CantiereDetailPage';
import MieiProgettiPage from '@/pages/MieiProgettiPage';
import FatturazionePage from '@/pages/FatturazionePage';
import PreventiviPage from '@/pages/PreventiviPage';
import MieAttivitaPage from '@/pages/MieAttivitaPage';
import ReportsPage from '@/pages/ReportsPage';
import UsersManagementPage from '@/pages/UsersManagementPage';
import AdminResetPage from '@/pages/AdminResetPage';
import ImpostazioniPage from '@/pages/ImpostazioniPage';
import AccordiQuadroPage from '@/pages/AccordiQuadroPage';
import ControlloGestionePage from '@/pages/ControlloGestionePage';
import ReportOrePage from '@/pages/ReportOrePage';
import AIAssistantPage from '@/pages/AIAssistantPage';
import FeedbackManagementPage from '@/pages/FeedbackManagementPage';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      setIsAuthenticated(true);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const handleAuthSuccess = (authData) => {
    setIsAuthenticated(true);
    setUser(authData.user);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigator.serviceWorker?.controller?.postMessage('clear-api-cache');
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-slate-600">Caricamento...</p>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster position="top-right" />
      <OfflineBanner />
      <BrowserRouter>
        {/* Timer attivo globale - visibile su tutte le pagine quando autenticato */}
        {isAuthenticated && <ActiveTimerIndicator />}
        {isAuthenticated && <PendingSyncPanel />}
        {/* Chatbot AI DISABILITATO */}
        {/* {isAuthenticated && <FloatingChatbot />} */}
        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? (
                <DashboardPage user={user} onLogout={handleLogout} />
              ) : (
                <AuthPage onAuthSuccess={handleAuthSuccess} />
              )
            } 
          />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route 
            path="/clienti" 
            element={
              isAuthenticated ? (
                <ClientiPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/ordini" 
            element={
              isAuthenticated ? (
                <OrdiniLavoroPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/progetti" 
            element={
              isAuthenticated ? (
                <ProgettiPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/cantieri" 
            element={
              isAuthenticated ? (
                <CantieriPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/cantieri/:id" 
            element={
              isAuthenticated ? (
                <CantiereDetailPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/accordi-quadro" 
            element={
              isAuthenticated ? (
                <AccordiQuadroPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/miei-progetti" 
            element={
              isAuthenticated ? (
                <MieiProgettiPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/fatturazione" 
            element={
              isAuthenticated ? (
                <FatturazionePage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/preventivi" 
            element={
              isAuthenticated ? (
                <PreventiviPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/mie-attivita" 
            element={
              isAuthenticated ? (
                <MieAttivitaPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/reports" 
            element={
              isAuthenticated ? (
                <ReportsPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />

          <Route 
            path="/utenti" 
            element={
              isAuthenticated ? (
                <UsersManagementPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/impostazioni" 
            element={
              isAuthenticated ? (
                <ImpostazioniPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/admin/reset" 
            element={
              isAuthenticated ? (
                <AdminResetPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/controllo-gestione" 
            element={
              isAuthenticated ? (
                <ControlloGestionePage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/report-ore" 
            element={
              isAuthenticated ? (
                <ReportOrePage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/ai-assistant" 
            element={
              isAuthenticated ? (
                <AIAssistantPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
          <Route 
            path="/feedback-management" 
            element={
              isAuthenticated ? (
                <FeedbackManagementPage user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
